import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faq } from '../data/faq';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="questions" className="bg-bone py-16 lg:py-24" data-id="element-84" data-mp="1gd7hib8p3f72">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-85" data-mp="1gaurdass9yix">
        <div className="grid gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-86" data-mp="2dz4vpwg1kyd7">
          <SectionHeading title="Les questions qu’on me pose au téléphone" data-id="element-87" data-mp="290tidbqjg5q8" />

          <div className="border-t border-bone-dark" data-id="element-88" data-mp="2429wtcfuwvye">
            {faq.map((item, index) => {
            const isOpen = openIndex === index;
            return <div key={item.question} className="border-b border-bone-dark" data-id="element-89" data-mp="1z2x8sod91iu8" data-mpi={index}>
                  <h3 data-id="element-90" data-mp="sooadz1dt8gk">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-91" data-mp="sl0ggys0yk1b">
                      <span className="font-display text-base font-bold text-ink-900 sm:text-lg" data-id="element-92" data-mp="fiqfs9jsb0vp">
                        {item.question}
                      </span>
                      <PlusIcon className={`mt-1 h-5 w-5 flex-none text-brass transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-93" data-mp="6rq1pbw6ltig" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-94" data-mp="1svablk5ewmq">
                    {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-95" data-mp="3jz9n3h6ol0jj">
                        <p className="max-w-2xl pb-6 pr-8 text-sm leading-relaxed text-ink-600" data-id="element-96" data-mp="1krb1ul56k7t2">
                          {item.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}